import { Typography } from '@mui/material';

type Props = {
    text: string;
};

const Title = ({ text }: Props) => {
    return (
        <Typography variant={'h4'} style={{ margin: '20px 0' }}>
            {text}
        </Typography>
    );
};

export default Title;
